import { useEffect, useState } from 'react';

// Level-ups waiting to be celebrated, shown one at a time by <LevelUpHost />
// at the root. While one is on screen, other popups (Sheet) hold back.
export interface LevelUp {
  category: string;
  level: number;
  xp: number; // total XP in the category after the gain
}

let queue: LevelUp[] = [];
const listeners = new Set<() => void>();
const notify = () => listeners.forEach(l => l());

export function queueLevelUps(ups: LevelUp[]) {
  if (!ups.length) return;
  queue = [...queue, ...ups];
  notify();
}

export function dismissLevelUp() {
  queue = queue.slice(1);
  notify();
}

function useQueue(): LevelUp[] {
  const [, rerender] = useState(0);
  useEffect(() => {
    const l = () => rerender(n => n + 1);
    listeners.add(l);
    return () => { listeners.delete(l); };
  }, []);
  return queue;
}

export function useCurrentLevelUp(): LevelUp | null {
  return useQueue()[0] ?? null;
}

export function useCelebrating(): boolean {
  return useQueue().length > 0;
}
